<div class="w-full h-full py-[12px] px-[20px] flex flex-col gap-[10px] overflow-y-auto">
  <div class="relative flex items-center justify-center mb-2">
    <h3 class="text-[32px] leading-[32px] font-bold text-black">Choose Members</h3>
    <ion-buttons slot="end" class="absolute right-0">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </div>

  <div class="flex flex-col gap-y-[25px] mb-[25px]">
    <div class="text-left">Add members that you would like to follow.</div>
    <div class="text-left font-semibold">Suggested Members</div>
  </div>

   @if (!hasLoaded) {
     <div class="flex items-center justify-center h-full">
        <ark-spinner></ark-spinner>
      </div>
    }

    @if (hasLoaded && suggestedUsers.length === 0) {
      <ion-card class="mx-5 mt-5 text-center">
        <ion-card-content class="text-black text-[16px] leading-[26px]">
          No suggested members at this time.
        </ion-card-content>
      </ion-card>
    }

    <div
      *ngFor="let user of suggestedUsers"
      class="flex flex-col cursor-pointer"
      (click)="goToProfile(user.userId)"
    >
      <div class="flex items-center gap-3 py-3 px-5 w-full">
        <img
          [src]="user.nft ? user.nft : 'https://www.gravatar.com/avatar/?d=mp'"
          alt="{{ user.nickname }}"
          class="w-12 h-12 rounded-full object-cover shrink-0"
        />
        <div class="min-w-0 flex-1">
          <div class="font-semibold text-sm truncate" [title]="displayNickname(user.nickname)">
            {{ displayNickname(user.nickname) }}
          </div>
          @if (user.name) {
            <div class="text-gray-500 text-xs truncate" [title]="user.name">{{ user.name }}</div>
          }
        </div>

        <div class="flex-shrink-0" (click)="$event.stopPropagation()">
          @if (!user.isSubscribed) {
            <ark-button
              [type]="'secondary'"
              leftIcon="system-star-plus"
              iconColor="dark"
              (click)="followUser(user.userId, $event)"
              classess="!h-[40px] !border-[1px] !border-solid !border-[#c8c8cd]"
            >
              FOLLOW
            </ark-button>
          }
          @if (user.isSubscribed) {
            <button
              class="p-2 w-[36px] h-[32px] flex items-center justify-center"
              style="border: 1px solid #c8c8cd; border-radius: 4px"
              (click)="unfollowUser(user.userId, $event)"
            >
              <ion-icon name="close-outline"></ion-icon>
            </button>
          }
        </div>
      </div>

      <div class="w-full bg-[#F1F1F2] h-[1px] border-y-[1px] border-[#F2F2F0]"></div>
    </div>

  @if (nextPage) {
    <div class="flex justify-center py-4">
      <button
        [disabled]="loading"
        class="px-6 py-2 text-sm"
        style="border: 1px solid #c8c8cd; border-radius: 4px"
        (click)="loadMore()"
      >
        @if (!loading) {<span>Load More</span>}
        @if (loading) {<span>Loading...</span>}
      </button>
    </div>
  }
</div>
